import { render, staticRenderFns } from "./MainInputContainer.vue?vue&type=template&id=8fcce66e&scoped=true&"
import script from "./MainInputContainer.vue?vue&type=script&lang=js&"
export * from "./MainInputContainer.vue?vue&type=script&lang=js&"
import style0 from "./MainInputContainer.vue?vue&type=style&index=0&id=8fcce66e&prod&lang=scss&"
import style1 from "./MainInputContainer.vue?vue&type=style&index=1&id=8fcce66e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcce66e",
  null
  
)

export default component.exports